/*eslint-disable*/
import React from 'react'
import { Formik, Field as Fieldmik } from 'formik';
import * as yup from 'yup';
import { Form as FormUi, Container, Button, Label, Modal, } from 'semantic-ui-react';
import Axios from 'axios';

import { MyInput, MyTextArea } from '../../formikInput/input';
import APP_CONSTANTS from '../../../config/constants';
import cogoToast from 'cogo-toast';


const AddVendorUserModal = ({ handleCloseUserAddModal, user, vendorId, ...props }) => {

    const initialValues = {
        username: '',
        password: '',
        name: '',
        email: '',
        phone: '',
    };

    const validateSchema = yup.object().shape({
        username: yup.string().required('Branch Name Required'),
    });

    const onSubmit = (values, onSubmitProps) => {

        const userData = {
            customerNo: localStorage.getItem('customerNo'),
            customerNumber: localStorage.getItem('customerNo'),
            customer_no: localStorage.getItem('customerNo'),
            userId: localStorage.getItem('userId'),
            user_id: localStorage.getItem('userId'),
            consigneeId: "",
            consignorId: "",
            email: values.email,
            mobileNo: values.phone,
            password: values.password,
            realName: values.name,
            userName: values.username,
            vendorId: vendorId
        }
        
        Axios.put(`${APP_CONSTANTS.BASE_URL}masters/users/vendor`, userData, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localStorage.getItem('apiToken')
            }
        }).then((response => {
            cogoToast(response.data.message, { position: 'top-right'}) 
            window.location.reload()      
        }))
            .catch(error => {
                console.log(error);
                onSubmitProps.setSubmitting(false);
            })        

    };

    return (
        <>
            <Formik 
                initialValues={initialValues}
                validationSchema={validateSchema}
                onSubmit={onSubmit}
            >
                {({ values, isSubmitting, errors, touched, handleSubmit }) => (
                    <>
                        
                        <Modal.Content>
                            <Container>
                            {console.log("Values", user)}
                                <div className="ui form">
                                    <FormUi.Group>
                                        <FormUi.Field>
                                            <label className="labelName p-bold-600">Username</label>
                                            <Fieldmik name="username" component={MyInput} error={values.username ? false : true} placeholder="Enter Username" />
                                            {touched.username && errors.username ? <Label size="mini" prompt pointing>{errors.username}</Label> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field>
                                            <label className="labelName p-bold-600">Password</label>
                                            <Fieldmik type="password" name="password" component={MyInput} error={values.password ? false : true} placeholder="Enter Password" />
                                            {touched.password && errors.password ? <Label size="mini" prompt pointing>{errors.password}</Label> : ''}
                                        </FormUi.Field>
                                    </FormUi.Group>
                                    <FormUi.Group>
                                        <FormUi.Field>
                                            <label className="labelName p-bold-600">Name</label>
                                            <Fieldmik name="name" component={MyInput} error={values.name ? false : true} placeholder="Enter Name" />
                                            {touched.name && errors.name ? <Label size="mini" prompt pointing>{errors.name}</Label> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field>
                                            <label className="labelName p-bold-600">Email</label>
                                            <Fieldmik name="email" component={MyInput} error={values.email ? false : true} placeholder="xyz@123.com" />
                                            {touched.email && errors.email ? <Label size="mini" prompt pointing>{errors.email}</Label> : ''}
                                        </FormUi.Field>
                                    </FormUi.Group>
                                    <FormUi.Group>
                                        <FormUi.Field>
                                            <label className="labelName p-bold-600">Phone</label>
                                            <Fieldmik name="phone" component={MyInput} error={values.phone ? false : true} placeholder="Enter Phone Number" />
                                            {touched.phone && errors.phone ? <Label size="mini" prompt pointing>{errors.phone}</Label> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field />
                                    </FormUi.Group>       
                                </div>
                            </Container>
                        </Modal.Content>
                        <Modal.Actions>
                            <Button onClick={handleCloseUserAddModal} size="mini">Cancel</Button>
                            <Button disabled={isSubmitting} type="submit" onClick={handleSubmit} size="mini" primary>Submit</Button>
                        </Modal.Actions>
                    </>
                )}
            </Formik>
        </>
    )
}


export default AddVendorUserModal
